import Vue from 'vue'
import { ActionTree } from 'vuex'
import RootState from '@vue-storefront/core/types/RootState'
import VacanciesState from '../types/VacanciesState'
import * as types from './mutation-types'
import i18n from '@vue-storefront/i18n'
import rootStore from '@vue-storefront/core/store'
import config from 'config'
import { processURLAddress } from '@vue-storefront/core/helpers'
import fetch from "isomorphic-fetch";

const actions: ActionTree<VacanciesState, RootState> = {
  sendApplicationEmail (context, payload) {
    let aplyFile = payload.application
    let vacancyData = payload.vacancyData
    let userPersonalData = payload.userPersonalData
    let form = new FormData()
    form.append('application', aplyFile.file)
    form.append('vacancyData', JSON.stringify(vacancyData))
    form.append('userPersonalData', JSON.stringify(userPersonalData))
    let url = processURLAddress(`${config.vacancies.base_endpoint}/sendApplication`)
    return fetch(url, {
      method: 'POST',
      body: form
    })
      .then(res => res.json())
      .then(res => res)
  },

  createApplicant (context, payload) {
    let form = new FormData()
    form.append('application', payload.userPersonalData.file)
    form.append('userPersonalData', JSON.stringify(payload.userPersonalData.user))
    let url = processURLAddress(`${config.vacancies.base_endpoint}/createApplicant`)
    return fetch(url, {
      method: 'POST',
      body: form
    })
      .then(res => res.json())
      .then(response => {
        return response
      })
      .catch(error => {
        throw new Error('FetchError in request: ' + error.toString())
      })
  }
}

export default actions
